define([
	"require",
	"jquery"
], function(require, $){
	/* =======================================================================================
	Requires:		arguments.

	Arguments:		msg is the message to be displayed inside the dialog.
					icon is the type of icon to be displayed next to the message.
					icon can have the following values:

						error
						notice
						warning
						success

	Function:		this function pops up an alert dialog with a message and and icon that are
					specified by the user.

	Destructive:	NO
	======================================================================================= */
	function showMessageDialog(msg, icon){
		icon = icon.toLowerCase();

		// Create the deferred object to return
		var deferred = new $.Deferred();

		// build new modal
		var $modalContainer = $('<div class="tiny reveal vfrs-alert-dialog-js" data-reveal></div>'),
			$modalIcon = $('<div class="vfrs-dialog-icon-js"><div class="' + icon + '-icon-js"></div></div>'),
			$modalText = $('<div class="vfrs-dialog-text-js"><p>' + msg + '</p></div>'),
			$modalClose = $('<a class="close-button" data-close aria-label="Close"><span class="icon-close"></span></a>');

		$modalContainer.append($modalIcon);
		$modalContainer.append($modalText);
		$modalContainer.append($modalClose);

		// Modal is ready, open it
		require(["foundation.reveal"], function() {
			// Close all other notifications if opened
			var $modals = $('.vfrs-alert-dialog-js');
			$modals.each(function() {
				var $this = $(this),
					plugin = $this.data('zfPlugin');
				if(plugin && (plugin instanceof Foundation.Reveal)) {
					$this.foundation('close');
				}
			});

			$('body').append($modalContainer);

			$modalContainer.on('open.zf.reveal',function(e) {
				// Notify the promise that it opened and pass the modal object
				deferred.notifyWith($(this), ['opened']);
			});

			$modalContainer.on('closed.zf.reveal',function(e) {
				$modalContainer.foundation('_destroy');
				e.currentTarget.remove();
				deferred.notify('closed');
				// Resolve the promise once closed
				deferred.resolve(this);
			});

			// We have to do this in 2 steps
			// Initialize the modal container
			$modalContainer.foundation();
			// open the modal container
			$modalContainer.foundation('open');
		});

		return deferred.promise();
	}

	/***
	 * Replaces the contents .page-messaging-js with the specified message
	 * @param string Message to display
	 * @param string CSS class to use on the message {error|success}
	 **/
	function showPageNotification(msg, notificationStatus, options){
		var $el = $('.page-notification-js');
		if($el.length > 0) {
			insertNotification($el, msg, notificationStatus, options);
			hideLoadingNotification();
			window.scrollTo(0, 0);
		}
	}

	/***
	 * Replaces the contents of .hopup-notification-js with the specified message
	 * @param string Message to display
	 * @param string CSS class to use on the message {error|success}
	 **/
	function showHopupNotification(msg, notificationStatus){
		var $el = $('.hopup-notification-js');
		if($el.length > 0) {
			insertNotification($el, msg, notificationStatus);
		}
	}

	/***
	 * Replaces the contents of the specified element with a formatted message
	 * @param JQuery Element to insert the message into
	 * @param string Message to display
	 * @param status String CSS class to set on the message
	 **/
	function insertNotification($element, msg, msgClass, options) {
		var $message = '<section class="page-messaging-js"><div><p role="alert" aria-live="assertive" class="message ' + msgClass + '"></p></div></section>',
		insertFunction = 'html';

		$element.html($message);

		if(typeof options === 'object' && options.escapeHtml) {
			insertFunction = 'text';
		}

		$('.page-messaging-js .message.' + msgClass, $element)[insertFunction](msg);
	}

	function clearPageNotification(){
		$('.page-notification-js').html('');
	}


	function showSpinner($spinner, type) {
		var loadingIndicatorText,
			$indicator = $('<div class="activity-indicator">'),
			$text = $('<div class="loading-spinner-text">');

		switch (type) {
			case 's':
				loadingIndicatorText = typeof LOADING_INDICATOR_TEXTS !== 'undefined' ? LOADING_INDICATOR_TEXTS.SAVE : '';
				break;
			case 'p':
				loadingIndicatorText = typeof LOADING_INDICATOR_TEXTS !== 'undefined' ? LOADING_INDICATOR_TEXTS.PROCESS : '';
				break;
			case 'u':
				loadingIndicatorText = typeof LOADING_INDICATOR_TEXTS !== 'undefined' ? LOADING_INDICATOR_TEXTS.UPDATE : '';
				break;
			default:
				loadingIndicatorText = typeof LOADING_INDICATOR_TEXTS !== 'undefined' ? LOADING_INDICATOR_TEXTS.LOAD : '';
				break;
		}

		$text.text(loadingIndicatorText);
		$spinner.empty();
		$spinner.append($indicator);
		$spinner.append($text);
		$spinner.removeClass('hide');
	}

	function hideSpinner($spinner) {
		$spinner.addClass('hide');
	}

	function showLoadingNotification(type) {
		var $spinner = $('#loading-spinner');
		if ($spinner.length < 1) {
			$spinner = $('<div id="loading-spinner" class="loading-spinner hide" role="alert" aria-live="assertive">');
			$('body').append($spinner);
		}

		showSpinner($spinner, type);
	}

	function showLoadingNotificationByPosition(type, parentElement) {
		var $parent = $(parentElement),
			$spinner = $('.loading-spinner.inline',$parent);
		if ($spinner.length < 1) {
			$spinner = $('<div class="loading-spinner inline hide" role="alert" aria-live="assertive">');
			$parent.append($spinner);
		}

		showSpinner($spinner, type);
	}

	function hideLoadingNotification() {
		var $spinner = $('#loading-spinner');

		hideSpinner($spinner);
	}

	function hideLoadingNotificationByPosition(parentElement) {
		var $parent = $(parentElement),
			$spinner = $('.loading-spinner',$parent);

		hideSpinner($spinner);
	}

	return {
		showMessageDialog: showMessageDialog,
		showPageNotification: showPageNotification,
		showHopupNotification: showHopupNotification,
		clearPageNotification: clearPageNotification,
		showLoadingNotification : showLoadingNotification,
		hideLoadingNotification : hideLoadingNotification,
		showLoadingNotificationByPosition : showLoadingNotificationByPosition,
		hideLoadingNotificationByPosition : hideLoadingNotificationByPosition
	};

});
